<div class="bot-message-content" markdown [data]="message.content"></div>
